import { useContext } from 'react'
import { AppMainContext } from '../context/AppMainContext';
import { useNavigate } from 'react-router-dom';

export default function ShowHistory() {
    const {showHistoryFlag, handleShowHistory} = useContext(AppMainContext);
    const nav = useNavigate();
    return (
        <div className='showHistory_div'>
            <button className="showHistory_btn" disabled={showHistoryFlag} onClick={()=>{handleShowHistory(nav)}}>{showHistoryFlag ? "המתן..." : "הצג היסטוריה"}</button>
        </div>
    )
}
